








import Vue from 'vue'
import { mapGetters } from 'vuex'
import { Mutation } from '@/store/interview'

export default Vue.extend({
  computed: {
    uncaughtErrors(): object[] {
      return this.$store.getters['interview/offers/uncaughtErrors'] as object[]
    },
    hasErrors: {
      get(): boolean {
        return this.uncaughtErrors.length > 0
      },
      set(value: boolean) {
        if (value === false) {
          this.uncaughtErrors.forEach(error =>
            this.$store.commit({
              error,
              type: 'interview/offers/clearError',
            })
          )
        }
      },
    },
  },
})
